/* tslint:disable */
import {
  UserRole
} from '../index';

declare var Object: any;
export interface UserDataInterface {
  "active"?: boolean;
  "partnerId"?: string;
  "termsAccepted"?: boolean;
  "firstName"?: string;
  "middleName"?: string;
  "lastName"?: string;
  "extensionName"?: string;
  "contactNumber"?: string;
  "approvalStatus": number;
  "loginAttempt"?: number;
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "id"?: number;
  "password"?: string;
  accessTokens?: any[];
  roles?: UserRole[];
}

export class UserData implements UserDataInterface {
  "active": boolean;
  "partnerId": string;
  "termsAccepted": boolean;
  "firstName": string;
  "middleName": string;
  "lastName": string;
  "extensionName": string;
  "contactNumber": string;
  "approvalStatus": number;
  "loginAttempt": number;
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "id": number;
  "password": string;
  accessTokens: any[];
  roles: UserRole[];
  constructor(data?: UserDataInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserData`.
   */
  public static getModelName() {
    return "UserData";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserData for dynamic purposes.
  **/
  public static factory(data: UserDataInterface): UserData{
    return new UserData(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserData',
      plural: 'UserData',
      path: 'UserData',
      idName: 'id',
      properties: {
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "termsAccepted": {
          name: 'termsAccepted',
          type: 'boolean'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "middleName": {
          name: 'middleName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "extensionName": {
          name: 'extensionName',
          type: 'string'
        },
        "contactNumber": {
          name: 'contactNumber',
          type: 'string'
        },
        "approvalStatus": {
          name: 'approvalStatus',
          type: 'number',
          default: 1
        },
        "loginAttempt": {
          name: 'loginAttempt',
          type: 'number',
          default: 0
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        roles: {
          name: 'roles',
          type: 'UserRole[]',
          model: 'UserRole',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'principalId'
        },
      }
    }
  }
}
